interface IProps {
  backgroundColor?: string;
  color?: string;
  label: string;
  handleOpenDialog: () => void;
}

const CustomButton = ({
  backgroundColor = '#486BC2',
  color = '#EEEFF3',
  label,
  handleOpenDialog,
}: IProps) => {
  return (
    <button
      style={{
        border: 'none',
        width: '100%',
        height: 44,
        borderRadius: 30,
        backgroundColor: backgroundColor,
        color: color,
        cursor: 'pointer',
      }}
      onClick={() => handleOpenDialog()}
    >
      {label}
    </button>
  );
};

export default CustomButton;
